<template>
<div style="background:#fff;overflow-x: hidden;">
    <BillQueryGrid ref="billqureygrid"  v-show="!showHead" :config="myConfig.billQueryConfig" :dictData="dictData" :moduleMethod="moduleMethod"  @doAction="doAction" />
    <BillDetailForm ref="form" v-show="showHead" :config="myConfig.detailConfig" :dictData="dictData" :moduleMethod="moduleMethod"  @doAction="doAction">
      <Affix slot="toolbar">
        <Card :padding="0" style="padding:14px 16px;border-radius:0px;" dis-hover>
            <DetailBtnToolbar ref="menutoolbar" :config="menuToolbar"  :moduleMethod="moduleMethod"   @doAction="doAction"/>
        </Card>
    </Affix>
    </BillDetailForm>   
    <BillImport ref="billImport" :config="billImportConfig"> </BillImport>
    <ApprovalBox ref="approval" :config="billApprovalConfig"/>
    <Modal class-name="efuture-billapprovalmainframe" v-model="showApproval" fullscreen title="报批单" footer-hide>
        <iframe  frameborder="0" ref="billapprovalmainframe" style="width:100%;height:100%;" border="0"></iframe>
    </Modal>
</div>
</template>

<script>
import BillQueryGrid from './billquerygrid.vue';
import BillDetailForm from './billdetailform.vue';
import BillImport from './billimport.vue';
import ApprovalBox from './approval.vue';
export default {
    name:'listdetails',
     components: {BillQueryGrid,BillDetailForm,BillImport,ApprovalBox},
    data () {
        return {
            showHead:false,
            myConfig:{
            },
            billKey:'ph_key',
            ph_key:'',
            billImportConfig:{
                importKey:'billno',
                typeData:[]
            },
            billApprovalConfig: {
                resources: '',
                classPrefix: '',
            },
            menuToolbar:{
                statusKey:'billstatus'
            },
            billapproveurl:'',
            showApproval:false
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        }
    },
    created () {
        this.myConfig =  Object.assign({},this.myConfig, this.config);
        // 处理列表
        this.myConfig.billQueryConfig.response = this.myConfig.response;
        this.myConfig.billQueryConfig.resources = this.myConfig.resources;
        this.myConfig.billQueryConfig.classPrefix = this.myConfig.classPrefix;
        this.myConfig.billQueryConfig.gridConfig.height = 1;
        this.myConfig.billQueryConfig.gridConfig.adjustHeight = 0;
        this.myConfig.billQueryConfig.btnData = [];
        this.myConfig.billQueryConfig.rowBtnData = [];
        if(this.myConfig.menuToolbar.enablePermissions !== undefined) {
            this.myConfig.billQueryConfig.enablePermissions = this.myConfig.menuToolbar.enablePermissions;
        }
        if (this.myConfig.detailConfig.billapproveurl) {
            this.myConfig.menuToolbar.billapproval = true;
        }
        if (this.myConfig.billKey) {
            this.billKey = this.myConfig.billKey;
        }
        this.myConfig.billQueryConfig.gridConfig.bindSearchParam = this.billKey;
        this.myConfig.menuToolbar.items.forEach(el => {
            if (el.btntype === 'batch') {
                this.myConfig.billQueryConfig.btnData.push(this.$Method.copy(el));
            }
            if (el.btntype === 'row') {
                this.myConfig.billQueryConfig.rowBtnData.push(this.$Method.copy(el));
            }
        });

        if (this.myConfig.billImportConfig) {
            this.billImportConfig = Object.assign({},this.billQueryConfig, this.myConfig.billImportConfig);
        }

        // 处理详情
        if (this.myConfig.detailConfig.showAnchorLink === undefined) {
            this.myConfig.detailConfig.showAnchorLink = false;
        }
        if (this.myConfig.detailConfig.showAnchorLink) {
            if (this.myConfig.detailConfig.anchorCol === undefined) {
                this.myConfig.detailConfig.anchorCol = 3;
            }
        }
        this.myConfig.detailConfig.billKey = this.billKey;
        this.myConfig.detailConfig.adjustHeight = 0;
        this.myConfig.detailConfig.modulecode = this.myConfig.modulecode;
        this.myConfig.detailConfig.resources = this.myConfig.resources; 
        this.menuToolbar = Object.assign({},this.menutoolbar,this.myConfig.menuToolbar);
        this.menuToolbar.billisworkflow = this.myConfig.billisworkflow;
        if (this.myConfig.detailConfig.billapproveurl) {
            this.menuToolbar.billapprove = true;
        }
        this.menuToolbar.items = [];
        this.myConfig.menuToolbar.items.forEach(el => {
            if (!el.btntype || (el.btntype !== 'batch' && el.btntype !== 'row')) {
                this.menuToolbar.items.push(this.$Method.copy(el));
            }
        });

        if (this.myConfig.billAppendixConfig) {
            this.myConfig.detailConfig.billAppendixConfig = this.myConfig.billAppendixConfig;
        }
        if (this.myConfig.billOperLogConfig) {
            this.myConfig.detailConfig.billOperLogConfig = this.myConfig.billOperLogConfig;
        }
        this.billApprovalConfig.resources = this.myConfig.resources;
        this.billApprovalConfig.classPrefix = this.myConfig.classPrefix;
    },
    methods:{
        doAction (obj) {
            if (obj.name === 'gridSelectionChange' ) {
                if (this.$parent[obj.name]) {
                    this.$parent[obj.name](obj);
                }
                return true;
            }
            const method = obj.name;
            const methodBefore = method + 'Before';
            const methodAfter = method + 'After';
            if (obj.name === 'skipData' || obj.name === 'gridDbClick' || obj.name === 'backData' || obj.name === 'searchData'
                || obj.name === 'editData' || obj.name === 'addData' || obj.name === 'preBill'  || obj.name === 'nextBill' || obj.name === 'resetData' || obj.name === 'openWorkFlow' ||  obj.name === 'openBillapproval') {
                let flag =  true;
                if (this.$parent[methodBefore]) {
                    flag = this.$parent[methodBefore]();
                }
                if (flag) {
                    // '跳转'
                    if (obj.name === 'skipData' || obj.name === 'gridDbClick') {
                        this.initForm(obj.para, obj.name);
                    }
                     // '跳转'
                    if (obj.name === 'openWorkFlow') {
                        this.openWorkFlow();
                    }
                      // '跳转'
                     if (obj.name === 'openBillapproval') {
                        this.openBillapproval();
                    }
                    // 返回
                    if (obj.name === 'backData') {
                        let temp = {};
                        let self = this;
                        temp.onOk = () => {
                            self.$refs.billqureygrid.refurbish();
                            self.$nextTick(() => {
                                self.showHead = false;
                            });
                        };
                        this.checkData(temp);
                    }
                    // 查询
                    if (obj.name === 'searchData') {
                        this.$refs.billqureygrid.getQuick().filterSearch();
                        /*this.setPhkey('');
                        this.ph_key = '';
                        this.$refs.billqureygrid.refurbish();
                        */
                    } 
                    // 重置
                    if (obj.name === 'resetData') {
                        this.$refs.billqureygrid.getQuick().clearData();
                    }  

                    // 编辑
                    if (obj.name === 'editData') {
                        this.$refs.form.setReadOnly(false);
                        this.getMenuToolbar().setReadOnly('editData', true);
                        this.getMenuToolbar().setReadOnly('saveData', false);
                        this.showHead = true;
                    }
                    // 新增
                    if (obj.name === 'addData') {
                        this.$refs.form.setReadOnly(false);
                        this.$refs.form.clearData();
                        this.getMenuToolbar().setAllReadOnly(true);
                        this.getMenuToolbar().setReadOnly('saveData', false);
                        this.showHead = true;
                    }
                    // 上一单 
                    if (obj.name === 'preBill') {
                        this.preBill();
                    }
                    // 下一单 
                    if (obj.name === 'nextBill') {
                        this.nextBill();
                    }
    
                    if (this.$parent[methodAfter]) {
                        this.$parent[methodAfter]();
                    }
                }
            } else {
                let data = this.$refs.form.getData();
                if (obj.name === 'saveData') {
                    let flag = this.$refs.form.checkValidate();
                    if (flag) {
                        this.alert('必填项不允许为空');
                        return false;
                    }
                    flag = this.$refs.form.isEdit();
                    if (flag) {
                        this.alert('存在数据未确认');
                        return false; 
                    }
                    obj.para = this.$refs.form.getChangeData();
                } 
                if (obj.name === 'saveDetails') {
                    obj.para = this.$refs.form.getChangeData(obj.detailsname);
                    obj.name = 'saveData';
                } 
                if (obj.name === 'delData') {
                    if (this.showHead) {
                        obj.para = data;
                        obj.para.flag = 'D';
                    } else {
                        if (obj.para instanceof Array) {
                            obj.para.forEach(el => {
                                el.flag = 'D';
                            });
                        } else {
                            obj.para.flag = 'D';
                            let temp = [obj.para];
                            obj.para = temp;
                        }
                    }
                }  
                if (obj.name === 'copyData') {
                    obj.para[this.billKey] = data[this.billKey];
                }
                obj.onOk = this.onOk;
                if (obj.name === 'delData' || obj.name === 'auditData' || obj.name === 'cancelData' || obj.name === 'revokeData') {
                    let text = '删除';
                    if (obj.name === 'auditData') {
                        text = '审核';
                        obj.para ={billno:data.billno};
                    }
                    if (obj.name === 'cancelData') {
                        text = '作废';
                        obj.para ={billno:data.billno};
                    }
                   
                    if (obj.name === 'revokeData') {
                        text = '撤回';
                        obj.para ={billno:data.billno};
                    }
                    if (this.$parent.getActionName) {
                        let name = this.$parent.getActionName(obj);
                        if (name) {
                            text = name;
                        }
                    }   
                    let info = '确定是否' + text + '单据？';
                    let self = this;
                    self.$Modal.confirm({
                        title:'确认',
                        content: info,
                        onOk:() => {
                            self.$emit('doAction', obj);
                        }
                    });
                }  else {
                    this.$emit('doAction', obj);
                }
            }
        },
        setShowHead (value) {
            this.showHead = value;
            if (!this.showHead) {
                this.$refs.billqureygrid.refurbish();
            } else {
                this.$resfs.form.doAnchorClick();
            }
        },
        setAllAnchorVisible(value) {
            this.$refs.form.setAllAnchorVisible(value);
        },
        setAnchorVisible(obj, value) {
            this.$refs.form.setAnchorVisible(obj,value);
        },
        setRowBtnVisible(value) {
            this.$refs.form.setRowBtnVisible(value);
        },
        setPhkey(value) {
            this.ph_key = value;
            this.$refs.billqureygrid.setPhkey(value);
        },
        onOk (action, data) {
            if (action.name === 'saveData') {
                this.$refs.form.updateAllfile();
                let key = '';
                if (data instanceof Array) {
                    key = data[0][this.billKey];
                } else {
                    key = data[this.billKey];
                }
                let tmp = {};
                tmp[this.billKey] = key;
                this.$refs.billqureygrid.setPhkey(key);
                this.initForm(tmp, action.name);
            }
            if (action.name === 'delData') {
                this.$refs.form.delAppenndix();
                this.ph_key = '';
                this.$refs.billqureygrid.setPhkey('');
                if (!this.showHead) {
                    this.$refs.billqureygrid.refurbish();
                }
                this.$refs.form.clearData();
                this.$refs.form.setReadOnly(true);
                this.getMenuToolbar().setAllReadOnly(true);
                this.getMenuToolbar().setReadOnly('addData', false);
            }
            if (action.name === 'auditData' || action.name === 'cancelData' || action.name === 'copyData') {
                let obj = {};
                obj[this.billKey] = this.ph_key;
                this.initForm(obj,action.name);
            }
        },
        initForm(para,methodName) {
            this.$refs.form.clearData();
            let data = this.getFormData(para);
            if (data[this.billKey]) {
                this.ph_key = data[this.billKey];
            } else {
                this.ph_key = '';
            }
            if (this.$parent.setBillData) {
                data = this.$parent.setBillData(data);
            }
            this.$refs.form.setData(data); 
            this.$nextTick(() => {
                this.$refs.form.setReadOnly(true);
            });
            let status = data[this.menuToolbar.statusKey];
            if (status) {
                this.changedStatus(status);
            } else {
                if (methodName === 'skipData' || methodName === 'gridDbClick') {
                    this.getMenuToolbar().setAllReadOnly(true);
                    this.getMenuToolbar().setReadOnly(['addData'], false);
                }
                if (methodName === 'saveData' || methodName === 'copyData' ) {
                    this.getMenuToolbar().setReadOnly(['addData','delData','editData','auditData'], false);
                    this.getMenuToolbar().setReadOnly('saveData', true);
                }
                if (methodName === 'auditData' || methodName === 'cancelData') {
                    this.getMenuToolbar().setAllReadOnly(true);
                    this.getMenuToolbar().setReadOnly(['addData'], false);
                }
            }
           
            if (this.$parent.initFormAfter) {
                this.$parent.initFormAfter(data);
            }
            this.showHead = true;
        },
        getMenuToolbar() {
            return this.$refs.menutoolbar;
        },
        getFormData (para) {
            let result = {};
            let self = this;
            let tmp = {};
            if (!para[this.billKey]) {
                tmp[this.billKey] = this.ph_key;
            } else {
                tmp[this.billKey] = para[this.billKey];
            }
            if (this.$parent.getFormData) {
                return this.$parent.getFormData(para);
            }
            self.synchroPost(self.myConfig.resources,self.myConfig.classPrefix+'.get', tmp, function (data) {
                result = data[self.config.response];
            });
            return result;
        },
        getForm() {
            return this.$refs.form;
        },
        getBillQureyGrid() {
            return this.$refs.billqureygrid.getGrid();
        },
        preBill () {
            let data  = this.$refs.billqureygrid.getGrid().getData();
            if (this.ph_key) {
                let index = data.findIndex(el => el[this.billKey] === this.ph_key);
                if (index > -1) {
                    if (index === 0) {
                        this.initForm(data[data.length-1]);
                    } else {
                        this.initForm(data[index-1]);
                    }
                } else {
                    this.initForm(data[data.length-1]);
                }
            } else {
                this.initForm(data[data.length-1]);
            }
        },
        nextBill () {
            let data  = this.$refs.billqureygrid.getGrid().getData();
            if (this.ph_key) {
                let index = data.findIndex(el => el[this.billKey] === this.ph_key);
                if (index > -1) {
                    if (index === data.length-1) {
                        this.initForm(data[0]);
                    } else {
                        this.initForm(data[index+1]);
                    }
                } else {
                    this.initForm(data[0]);
                }
            } else {
                this.initForm(data[0]);
            }
        },
        approvalOk() {
            this.refurbish(this.ph_key);
        },
        refurbish (ph_key, acitonName) {
            if (ph_key) {
                this.ph_key = ph_key;
            }
            if (this.showHead) {
                if (this.ph_key) {
                    let obj = {};
                    obj[this.billKey] = this.ph_key;
                    this.initForm(obj,acitonName);
                }
            } else {
                this.setPhkey(this.ph_key);
                this.$refs.billqureygrid.refurbish();  
            }
           
        },
        checkData (obj) {
            let tempflag = false;
            tempflag = this.$refs.form.isEdit();
            if (tempflag) {
                let self = this;
                self.$Modal.confirm({
                    title:'确认',
                    content:'单据存在数据未确认，是否放弃？',
                    onOk:() => {
                        this.checkChangeData(obj);
                    },
                    onCancel:() => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                this.checkChangeData(obj);
            }
        },
        checkChangeData(obj) {
            let flag = false;
            flag = this.$refs.form.isChange();
            if (flag) {
                let self = this;
                self.$Modal.confirm({
                    title:'确认',
                    content:'单据有修改未保存，是否放弃修改？',
                    onOk:() => {
                        if (obj.onOk) {
                            obj.onOk();
                        }
                    },
                    onCancel:() => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                if (obj.onOk) {
                    obj.onOk();
                }
            }
        },
        changedStatus(value) {
            this.$refs.menutoolbar.changedStatus(value);
        },
        getChangeData() {
            return this.$refs.form.getChangeData();
        },
        importSuccess(res) {
            if (this.billImportConfig.importSuccess) {
                this.billImportConfig.importSuccess(res);
            }
        },
        getBillImport () {
            return this.$refs.billImport;
        },
        getData() {
            return this.$refs.form.getData();
        },
        setDetailVisible(name,value) {
            this.$refs.form.setVisible(name, value);
        },
        openWorkFlow() {
            let data = this.$refs.form.getApprovalData();
            if (this.$parent.getApprovalData) {
                data = this.$parent.getApprovalData();
            }
            if (!data.billno || !data.billmoduleid || !obj.billstatus) {
                this.alert('单据信息不全，无法打开工作流');
                return;
            }
            this.$refs.approval.setData(data);
            this.$refs.approval.open();
        },
        openBillapproval() {
            let data = this.$refs.form.getData();
            let obj = {};
            obj.billno = data.billno;
            obj.billmoduleid = data.billmoduleid;
            if (!obj.billno) {
                return;
            }
            let self = this;
            let tmpUrl = '';
            if (this.myConfig.detailConfig.billapproveurl) {
                if (this.myConfig.detailConfig.billapproveurl.indexOf('?') == '-1') {
                    tmpUrl = this.myConfig.detailConfig.billapproveurl + '?billno=' + obj.billno +'&billmoduleid=' + obj.billmoduleid;
                } else {
                    tmpUrl = this.myConfig.detailConfig.billapproveurl + '&billno=' + obj.billno +'&billmoduleid=' + obj.billmoduleid;
                }
            } else {
                return;
            }
            this.$parent.initBillApprovalData();
            this.$refs.billapprovalmainframe.src = this.setUrlSuffix(tmpUrl,self);
            this.showApproval = true;
        }
    },
    mounted () {
    
    }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/masterplate/listdetails.vue